import React, { useState } from 'react';
import { Box } from '@mui/material';

import { ColumnPanelBody } from './ColumnPanelBody/ColumnPanelBody';
import { ColumnPanelFooter } from './ColumnPanelFooter/ColumnPanelFooter';
import { ColumnPanelSearch } from './ColumnPanelSearch/ColumnPanelSearch';

export const ColumnsPanelWithGrouping = props => {
  const [search, setSearch] = useState('');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '400px' }}>
      <ColumnPanelSearch setSearch={setSearch} />
      <ColumnPanelBody search={search} {...props} />
      <ColumnPanelFooter defaultTableState={props.defaultTableState} />
    </Box>
  );
};
